export class ActivationCompleteController {
    /* @ngInject */
    constructor($stateParams, authenticatedUser, flowService, installations) {
        this.$stateParams = $stateParams;
        this.username = authenticatedUser.identifier;
        this.flowService = flowService;
        this.installations = installations;
    }

    continueFlow() {
        this.flowService.nextFlow();
    }
}
